import type { ProviderSchedule } from "~/screens/Admins/Providers/constants/table";
import { adminProviders } from "~/services";

export const mapProviderToTableRow = (
  provider: adminProviders.AdminProvider,
): ProviderSchedule => ({
  id: String(provider.id),
  name: provider.name,
  scheduleAvailable: provider.scheduleAvailable,
  bookingConflicts: provider.bookingConflicts,
  scheduleLastModifiedAt: provider.scheduleLastModifiedAt,
});
